import { topics } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-18 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2 text-center">
          热门话题
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          全网影视爱好者正在热议的内容话题
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 border border-background-200/70 cursor-pointer hover:border-primary-300 hover:bg-primary-50 transition-all duration-200"
            >
              {topic.trending && (
                <i className="ri-fire-line text-sm text-primary-500"></i>
              )}
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{topic.name}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}